import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';
import { formatByMode } from '../../utils/creditFormat';

// Shared Credit <-> Cost display mode for every AI Usage screen. The toggle in the
// section header flips this once and every figure below re-renders in the chosen unit.

const CreditModeContext = createContext(null);

export function CreditModeProvider({ children, initialMode = 'credit' }) {
  const [mode, setMode] = useState(initialMode);
  const toggle = useCallback(() => setMode((m) => (m === 'credit' ? 'cost' : 'credit')), []);
  const format = useCallback((credits, opts) => formatByMode(credits, mode, opts), [mode]);
  const value = useMemo(
    () => ({ mode, setMode, toggle, isCost: mode === 'cost', format }),
    [mode, toggle, format]
  );
  return <CreditModeContext.Provider value={value}>{children}</CreditModeContext.Provider>;
}

export function useCreditMode() {
  const ctx = useContext(CreditModeContext);
  if (!ctx) {
    throw new Error('useCreditMode must be used within a CreditModeProvider');
  }
  return ctx;
}
